import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import { LineChart } from "../../lib/charts";
import { addDays, iso } from "../../lib/dates";
import { Notice, Stat } from "../../lib/ui";

/*
 * Periodic sales analytics – port of saledates.php (API: /api/sales/periodic). Default: last 7 days.
 * Unusual transactions: profit above 50,000 either way, or a loss.
 */

export default function PeriodicSales() {
  const api = useApi();
  const [f, setF] = useState({ from: iso(addDays(new Date(), -7)), to: iso(new Date()) });
  const [form, setForm] = useState(f);
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/sales/periodic", f).then(setD).catch((e) => setError(e.message)); }, [api, f]);
  const k = d?.kpis;
  return (
    <main className="pg">
      <PageHeader slug="saledates" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={(e) => { e.preventDefault(); setF({ ...form }); }}>
          <div className="field"><label htmlFor="pd-f">From</label><input id="pd-f" type="date" required value={form.from} onChange={(e) => setForm({ ...form, from: e.target.value })} /></div>
          <div className="field"><label htmlFor="pd-t">To</label><input id="pd-t" type="date" required value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} /></div>
          <button type="submit" className="btn primary">Apply</button>
        </form>
      </section>
      {d && (
        <>
          <div className="ui-stats">
            <Stat icon="fa-coins" tone="up" label="Total sales" value={n0(k.total_sales)} unit="TZS" />
            <Stat icon="fa-sack-dollar" label={`Profit · margin ${k.profit_margin}%`} value={n0(k.total_profit)} unit="TZS" />
            <Stat icon="fa-receipt" tone="muted" label="Transactions" value={n0(k.total_transactions)} />
            <Stat icon="fa-scale-balanced" tone="warn" label="Average line value" value={n0(k.avg_transaction_value)} unit="TZS" />
          </div>
          <section className="panel card-pad" style={{ marginBottom: "1.25rem" }}><h3>Daily trend</h3>
            <LineChart labels={d.trends.map((t) => t.sale_date)} series={[{ name: "Sales", values: d.trends.map((t) => t.total_sales) }, { name: "Profit", values: d.trends.map((t) => t.total_profit) }]} /></section>
          <div className="grid2">
            <section className="panel card-pad"><h3>Top 10 products</h3>
              <table className="tbl"><thead><tr><th>Product</th><th className="num">Qty</th><th className="num">Sales</th><th className="num">Margin</th></tr></thead>
                <tbody>{d.top_products.map((p) => <tr key={p.product_name}><td><b>{p.product_name}</b></td><td className="num mono">{n0(p.total_quantity)}</td>
                  <td className="num mono">{n0(p.total_sales)}</td><td className="num mono">{p.profit_margin ?? 0}%</td></tr>)}</tbody></table></section>
            <section className="panel card-pad"><h3>Unusual transactions</h3>
              {d.unusual.length === 0 ? <p style={{ color: "var(--muted)", margin: 0 }}>None in this period.</p> : (
                <table className="tbl"><thead><tr><th>Reference</th><th>Date</th><th className="num">Sales</th><th className="num">Profit</th></tr></thead>
                  <tbody>{d.unusual.map((u, i) => <tr key={i}><td className="mono">{u.transaction_reference || "–"}</td><td>{u.sale_date}</td>
                    <td className="num mono">{n2(u.total_sales)}</td><td className="num mono" style={{ color: u.total_profit < 0 ? "var(--danger)" : "var(--up)" }}>{n2(u.total_profit)}</td></tr>)}</tbody></table>)}
            </section>
          </div>
        </>
      )}
    </main>
  );
}
